import { FullScreenError } from '@moniebook-web/components/molecules/full-screen-error';
import { PAGES } from '@register-ui/utils';

interface NotFoundProps {
    actionLink?: string;
}

export function NotFound(props: Readonly<NotFoundProps>) {
    const { actionLink = PAGES.HOME } = props;

    return (
        <FullScreenError
            showLogo
            title='Oh No! Page not found!'
            message="The page you're looking for is probably no longer here or an error has occurred. Hit refresh or go back home."
            actionText='Back to home'
            actionLink={actionLink}
        />
    );
}
